import { MatSnackBar } from '@angular/material/snack-bar';
import { Component, Inject } from '@angular/core';
import { ApiService } from 'src/app/services/api.service';
import { WebSocketService } from 'src/app/services/websocket.service';
import { MatBottomSheet, MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { JwtService } from 'src/app/services/jwt.service';
import { MixpanelService } from 'src/app/services/mixpanel.service';

@Component({
  selector: 'app-client-onboarding',
  templateUrl: './client-onboarding.component.html',
  styleUrls: ['./client-onboarding.component.css'],
})
export class ClientOnboardingComponent {
  loaded: boolean = false;
  client = {
    dstServer: null,
    personInCharge: null,
    email: null,
    emailBCC: null,
    emailCrew: null,
    emailCrewBCC: null,
    emailUpdateCrew: null,
    emailUpdateCrewBCC: null,
    emailLeaderboard: null,
    emailLeaderboardBCC: null,
    androidVersion: null,
    iOSVersion: null,
    gameStages: null,
    mlStatus: null,
    adminAWSAccessKeyID: null,
    adminAWSSecretAccessKey: null,
    adminAWSSessionToken: null,
    clientName: null,
    appType: null,
    masterPwdType: null,
    privateProdDBHost: null,
    nodeAPIPort: null,
    insightAPIPort: null,
    cmsAPIPort: null,
    clientLogo: null,
    launchDate: null,
    clientEnvType: null,
    nginxAppPort: null,
    nginxWebPort: null,
    nodeAPIBranch: null,
    cmsAPIBranch: null,
    insightAPIBranch: null,
    labsAPIBranch: null,
    ansibleBranch: null,
    liquibaseRepoBranch: null,
    mgmntDBSource: null,
    // databasepwd: null,
    // dstToken: null,
    // newAPIMySQLPwd: null,
    // newZohoMySQLPwd: null,
    // alias: null,
  };
  mgmntDBSourceName;
  logoName;
  image;
  zip;
  date;
  clientInfo: boolean = false;
  emailInfo: boolean = false;
  hostInfo: boolean = false;
  emailerr: boolean = true;
  emailBCCerr: boolean = true;
  emailCrewerr: boolean = true;
  emailCrewBCCerr: boolean = true;
  emailUpdateCrewerr: boolean = true;
  emailUpdateCrewBCCerr: boolean = true;
  emailLeaderboarderr: boolean = true;
  emailLeaderboardBCCerr: boolean = true;
  options: any = {};
  logoUploaded: boolean;
  logoError: boolean = false;
  zipUploaded: boolean;
  zipError: boolean = false;
  buttonClicked: boolean = false;
  data: string = '';
  viewLog: boolean = null;

  constructor(private jwt: JwtService, private api: ApiService, private mixpanel: MixpanelService, private snackbar: MatSnackBar, private ws: WebSocketService, private _bottomSheet: MatBottomSheet) {}

  ngOnInit() {
    this.mixpanel.track("page_view", { page: "Client Onboarding", category: "Dashboard", button: "-"  })
    this.jwt.check();
    this.api.clientOnboardingOptions().subscribe(
      (data: any) => {
        this.loaded = true;
        if (data.status) {
          this.options = data.data;
        } else {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'failure',
          });
        }
      },
      (error) => {
        this.loaded = true;
      }
    );
    // ? used for testing from Preview tab
    // this .client = {
    //   "dstServer": "dev",
    //   "personInCharge": "Binoy",
    //   "email": "binoy@bigyellowfish.io",
    //   "emailBCC": "binoy@bigyellowfish.io",
    //   "emailCrew": "binoy@bigyellowfish.io",
    //   "emailCrewBCC": "binoy@bigyellowfish.io",
    //   "emailUpdateCrew": "binoy@bigyellowfish.io",
    //   "emailUpdateCrewBCC": "binoy@bigyellowfish.io",
    //   "emailLeaderboard": "binoy@bigyellowfish.io",
    //   "emailLeaderboardBCC": "binoy@bigyellowfish.io",
    //   "androidVersion": "1.0.1.19",
    //   "iOSVersion": "1.0.8",
    //   "gameStages": "10",
    //   "mlStatus": "enabled",
    //   "adminAWSAccessKeyID": "ASIA4NDGINF6SXLAP2FV",
    //   "adminAWSSecretAccessKey": "wuV13mZpVjXXAPw9oIo3OPVK5/zB6YM1hdIdi54x",
    //   "adminAWSSessionToken": "IQoJb3JpZ2luX2VjEFEaCmFwLXNvdXRoLTEiRzBFAiEAra6Kh7ST2Yd5aIkKAW47F1pp2hVVYfNzX8a3/4fvZOoCIGTCHDdq2X8ceJ7v+pnxt5NSMHlW9sCUCuOqMXqj2/TuKpUDCEoQAhoMODUyNzY1NDY5MDUzIgzLQU+WeXlpMIFF3zoq8gL0jkNNm5SmQP91+7xEd1dMvCifHWjuxvbt466c9ZcHCEY5opgci1Gwezii5fVoiGJqg/1r+geh3xlNH7ZyWqCjL2kkVfylHKCQrzh+JoHBZJAhgqz/AryEzyGoyqwP7YPpXJ0cIoReaQRsGZgVktjMxAc+rtR9rTV59SYVkRdcihh2+FUZcoK8qwxLPdNtTttFy5JMmgP5cjFekWbOVl+ruNlAXu8zEVsABoFR+8vZrc9jiDRsudhhQaf3D4UUkfnj1RteJ1k30Rg9y/wmj3i3fg8/fRnQr5ZdvZJY2QhLmsGVPO0lVx5Uye/GKGczLKKYh04SCKhm8F6ghKjqet4GbxPVkNVJ7Nq5eR7atEoaJLANZjkTTFIAXGj9S5iKHMOWBvnA6elmOmqJlnhthfiIYrSSpP9VBjUy0zJvL5vbUHYglBzTG0GihL0sAn2O8onCMbRUFxIzcPfLeU/rQOWw6ngeg3+8IFc/vGmW/WbpxOs2MPj59aEGOqYBIsuE9GV5jNcVsHzbvcrOEjBilmMiPoFEtqXnW+HErSIwCSm+6DEAHZxEO8vUYnbRG5PSR14YE/bIKZ3X6aMgpCeoj6pLvnLkuZJloslhtx5owD27pP35PPdwAbNBGb5PtxEW5KrSYhnB8unwFA0t9whADkVbAo7YH+LbZic3oGP8t3iHidwL80iNuZGEGlWkQqKbjgLL+VHAAl8zp8HCvp/Yg4IP6w==",
    //   "clientName": "byfuat",
    //   "appType": "yb",
    //   "masterPwdType": "token",
    //   "privateProdDBHost": "13.235.224.69",
    //   "nodeAPIPort": "6010",
    //   "insightAPIPort": "6012",
    //   "cmsAPIPort": "6011",
    //   "clientLogo": "https://s3-ap-south-1.amazonaws.com/byf/clientonboarding/upload/baww1_1681750912657.webp",
    //   "launchDate": "2023-04-17",
    //   "clientEnvType": "dev",
    //   "nginxAppPort": "443",
    //   "nginxWebPort": "443",
    //   "nodeAPIBranch": "master",
    //   "cmsAPIBranch": "master",
    //   "insightAPIBranch": "master",
    //   "labsAPIBranch": "master",
    //   "ansibleBranch": "master",
    //   "liquibaseRepoBranch": "master",
    //   "mgmntDBSource": "https://s3-ap-south-1.amazonaws.com/byf/clientonboarding/upload/dist (21).zip"
    // }
  }

  validateEmailList(control) {
    if (control.value && control.value.trim() !== '') {
      const emailRegex =
        /^\s*([\w+-.%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s*(,\s*([\w+-.%]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})\s*)*$/;
      if (emailRegex.test(control.value)) {
        return true;
      } else {
        return false;
      }
    }
    return true;
  }

  dateformat() {
    this.client.launchDate = this.getDateAsApiFormat(this.date);
  }

  getDateAsApiFormat(e) {
    e = new Date(e);
    return `${e.getFullYear()}-${this.twoDigit(
      e.getMonth() + 1)}-${this.twoDigit(e.getDate())}`;
  }

  twoDigit(e) {
    return String(
      Number(e).toLocaleString('en-US', {
        minimumIntegerDigits: 2,
        useGrouping: false,
      })
    );
  }

  appVersions() {
    this.client.androidVersion = this.options.appVersions[this.client.appType].android;
    this.client.iOSVersion = this.options.appVersions[this.client.appType].ios;
  }

  onFileSelected(event: any): void {
    this.image = event.target.files[0] ?? null;
    this.imageUrl();
  }

  imageUrl() {
    const formData = new FormData();
    formData.append('files', this.image );
    this.logoError = false;
    this.logoUploaded = false;
    this.api.clientOnboardingUpload( formData).subscribe(
      (data: any) => {
        if (data.status) {
          this.client.clientLogo = data.data[0].url;
          this.logoName = data.data[0].name;
          this.logoUploaded = true;
          this.logoError = false;
        } else {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'failure',
          });
          this.logoUploaded = null;
          this.logoError = true;
        }
      },
      (error) => {
        this.logoUploaded = null;
        this.logoError = true;
        console.error(error);
        this.snackbar.open("Please try again later", undefined, {
          duration: 5000,
          panelClass: 'failure',
        });
      }
    );
  }

  onFileSelected1(event: any): void {
    this.zip = event.target.files[0] ?? null;
    this.zipUrl();
  }

  zipUrl() {
    const formData = new FormData();
    formData.append('files', this.zip );
    this.zipError = false;
    this.zipUploaded = false;
    this.api.clientOnboardingUpload( formData).subscribe(
      (data: any) => {
        if (data.status) {
          this.client.mgmntDBSource = data.data[0].url;
          this.mgmntDBSourceName = data.data[0].name;
          this.zipError = false;
          this.zipUploaded = true;
        } else {
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'failure',
          });
          this.zipError = true;
          this.zipUploaded = null;
        }
      },
      (error) => {
        this.zipError = true;
        this.zipUploaded = null;
        console.error(error);
        this.snackbar.open("Please try again later", undefined, {
          duration: 5000,
          panelClass: 'failure',
        });
      }
    );
  }

  errorsEmail(emails, i) {
    if (i == 0) {
      this.emailerr = this.validateEmailList(emails);
    } else if (i == 1) {
      this.emailBCCerr = this.validateEmailList(emails);
    } else if (i == 2) {
      this.emailCrewerr = this.validateEmailList(emails);
    } else if (i == 3) {
      this.emailCrewBCCerr = this.validateEmailList(emails);
    } else if (i == 4) {
      this.emailUpdateCrewerr = this.validateEmailList(emails);
    } else if (i == 5) {
      this.emailUpdateCrewBCCerr = this.validateEmailList(emails);
    } else if (i == 6) {
      this.emailLeaderboarderr = this.validateEmailList(emails);
    } else if (i == 7) {
      this.emailLeaderboardBCCerr = this.validateEmailList(emails);
    }
  }

  onSubmit() {
    this.mixpanel.track("button_click", { page: "Client Onboarding", category: "Dashboard", button:"Submit" })
    this.data = '';
    this.buttonClicked = true;

    // ? Converting all number types to String
    this.client.nginxAppPort = this.client.nginxAppPort.toString();
    this.client.nginxWebPort = this.client.nginxWebPort.toString();
    this.client.nodeAPIPort = this.client.nodeAPIPort.toString();
    this.client.cmsAPIPort = this.client.cmsAPIPort.toString();
    this.client.insightAPIPort = this.client.insightAPIPort.toString();
    this.client.gameStages = this.client.gameStages.toString();

    this.api.clientOnboardingCreate( this.client ).subscribe(
      (data: any) => {
        if (data.status) {
          let param = {
            "task_id": `${data.data}`,
            "last_read_id": 0
          }
          this.ws.connect();
          this.ws.send( param );
          this.ws.dataChanged.subscribe(value => {
            this.viewLog = true;
            this.data += value;
            this.viewLogs();
          });
          this.ws.websocketClosed.subscribe(value => {
            this.buttonClicked = !value;
          });
        } else {
          this.buttonClicked = false;
          this.snackbar.open(data.message, undefined, {
            duration: 5000,
            panelClass: 'failure',
          });
        }
      },
      (error) => {
        console.error(error);
        this.buttonClicked = false;
      }
    );
  }

  viewLogs() {
    this.mixpanel.track("button_click", { page: "Client Onboarding", category: "Dashboard", button:"View Log" })
    this._bottomSheet.open(ChatbotResponse, { data: this.data });
  }

}

@Component({
  selector: 'client-onboarding-response',
  templateUrl: './client-onboarding-response.html',
})
export class ChatbotResponse {
  constructor(private _bottomSheetRef: MatBottomSheetRef<ClientOnboardingComponent>, @Inject(MAT_BOTTOM_SHEET_DATA) public data: []) {}
}
